import React from 'react';
import { defaultDescription, defaultTitle } from '../../_legacy/containers/constants/constants.js';
import Header from '../../_legacy/containers/common/Header.jsx';
import Footer from '../../_legacy/containers/common/Footer.jsx';
import { DEFAULT_TRANSLATION } from '../../_legacy/helpers/constants.js';
import { SanitizeHtml } from '../utils/SanitizeHtml';

export type NewMessagePreviewProps = {
  questionId?: number;
  handleAnswer?: (answer: { value: boolean; questionId: number }) => void;
  title?: string;
  titleRef?: React.RefObject<HTMLDivElement>;
  titleAriaLabel?: string;
  description?: string;
  showSkipButton?: boolean;
  isActive?: boolean;
  translation?: typeof DEFAULT_TRANSLATION;
};

export const NewMessagePreview = ({
  questionId = -1,
  handleAnswer = () => {},
  title = defaultTitle,
  titleRef,
  titleAriaLabel,
  description = defaultDescription,
  showSkipButton = false,
  isActive = true,
  translation = DEFAULT_TRANSLATION,
}: NewMessagePreviewProps) => {
  const handleSkip = () => {
    handleAnswer({
      value: true,
      questionId,
    });
  };

  return (
    <div>
      <Header
        title={title}
        titleRef={titleRef}
        titleAriaLabel={titleAriaLabel}
        showDescription={false}
        isActive={isActive}
        translation={translation}
      />

      <SanitizeHtml tabIndex={0} html={description} />

      <Footer
        showSkipButton={showSkipButton}
        onConfirm={handleSkip}
        isActive={isActive}
        skipAsContinue
        translation={translation}
        // Added those properties to satisfy the wrongly configured props from Footer
        value={undefined}
        commentAriaLabel={undefined}
        onChangeComment={undefined}
        optionalComment={null}
        shouldFocusOnComment={false}
        showTextComment={false}
        showOkButton={false}
        label={undefined}
      />
    </div>
  );
};
